import { render, staticRenderFns } from "./PageShowsAll.vue?vue&type=template&id=6f65ab40&"
import script from "./PageShowsAll.vue?vue&type=script&lang=js&"
export * from "./PageShowsAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports